export default {
  mutateCommonObj ({ commit }, payload) {
    commit('mutateCommonObj', payload)
  },
  mutateFormLoad ({ commit }, payload) {
    commit('mutateFormLoad', payload)
  },
  localizeCommonDropdown ({ commit }, payload) {
    commit('localizeCommonDropdown', payload)
  }
}
